import { tbwMetadataActionTypes, tbwStarterFileActionTypes } from '../constants/tbw-action-types';
import * as CONST from '../../utils/constants/tbw';
const intialState = {
    aemId: '',
    docId: 'Some-messagee',
    version: '2.0.0',
    tutorialTitle: '',
    appId: '',
    activeCards: [CONST.CARD_ID_STARTER],
    tutorialDesc: '',
    thumbnailImageUrl: '',
    heroImageUrl: '',
    templateUrl: '',
    introVideoUrl: '',
    imageCredit: '',
    experienceLevel: '',
    learningApproach: '',
    creativeFields: [],
    topics: [],
    tasks: [],
    tools: [],
    locale: 'en_US',
    isEnglishLocale: true,
    createdOn: '',
    modifiedOn: '',
    completionMessage: '',
    completionMedia: {},
    ututCreator: '',
    creatorAvatar: '',
    creatorBio: '',
    creatorBadge: '',
    curatorFeedback: '',
    transientDocId: false,
    templateSize: '',
    templateNeedLoc: false,
    imageCreditToAuthor: false,
    taxonomy: [],
    totalExperienceLevels: [],
    totalCreativeFields: [],
    totalTasks: [],
    totalTools: [],
    totalTopics: [],
    relatedContents: [],
    readOnly: false,
};

export const tbwMetadataReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case tbwMetadataActionTypes.UPDATE_TBW_META_TITLE:
            return { ...state, tutorialTitle: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_META_DESC:
            return { ...state, tutorialDesc: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_META_AEMID:
            return { ...state, aemId: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_META_APP_ID:
            return { ...state, appId: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_META_DOCID:
            return { ...state, docId: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_ACTIVE_CARDS:
            return { ...state, activeCards: payload };
        case tbwStarterFileActionTypes.UPDATE_TBW_STARTER_FILE_URL:
            return { ...state, templateUrl: payload };
        case tbwStarterFileActionTypes.UPDATE_TBW_STARTER_FILE_CREDIT:
            return { ...state, imageCredit: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_HERO_URL:
            return { ...state, heroImageUrl: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_THUMBNAIL_URL:
            return { ...state, thumbnailImageUrl: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_INTRO_VIDEO_URL:
            return { ...state, introVideoUrl: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_COMPLETION_MSG:
            return { ...state, completionMessage: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_COMPLETION_MEDIA:
            return { ...state, completionMedia: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_TOPICS:
            return { ...state, topics: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TBW_TOOLS:
            return { ...state, tools: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TBW_TASKS:
            return { ...state, tasks: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TBW_EXPERIENCE_LEVEL:
            return { ...state, experienceLevel: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_LEARNING_APPROACH:
            return { ...state, learningApproach: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_CREATIVE_FIELDS:
            return { ...state, creativeFields: payload };
        case tbwMetadataActionTypes.UPDATE_TOTAL_EXP_LEVELS:
            return { ...state, totalExperienceLevels: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TOTAL_CREATIVE_FIELDS:
            return { ...state, totalCreativeFields: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TOTAL_TASKS:
            return { ...state, totalTasks: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TOTAL_TOOLS:
            return { ...state, totalTools: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TOTAL_TOPICS:
            return { ...state, totalTopics: [...payload] };
        case tbwMetadataActionTypes.UPDATE_READ_ONLY_MODE:
            return { ...state, readOnly: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_LOCALE:
            return { ...state, locale: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_IS_ENGLISH_LOCALE_FLAG:
            return { ...state, isEnglishLocale: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_TRANSIENT_ID:
            return { ...state, transientDocId: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_TEMPLATE_SIZE:
            return { ...state, templateSize: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_TEMPLATE_NEED_LOC:
            return { ...state, templateNeedLoc: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_IMAGE_CREDIT_TO_AUTHOR:
            return { ...state, imageCreditToAuthor: payload };
        case tbwMetadataActionTypes.UPDATE_TBW_META_RELATED_CONTENTS:
            return { ...state, relatedContents: [...payload] };
        case tbwMetadataActionTypes.UPDATE_TOTAL_META_DATA:
            return {
                ...state,
                aemId: payload['aemId'],
                docId: payload['docId'],
                appId: payload['appId'],
                version: payload['version'],
                tutorialTitle: payload['tutorialTitle'],
                activeCards: [CONST.CARD_ID_STARTER],
                tutorialDesc: payload['tutorialDescription'],
                thumbnailImageUrl: payload['thumbnailImage'],
                heroImageUrl: payload['heroImage'],
                templateUrl: payload['template'],
                introVideoUrl: payload['introVideoUrl'] ?? '',
                //templateContainsText: payload["templateContainsText"],
                // templateCreditIsAuthor: payload["templateCreditIsAuthor"],
                imageCredit: payload['imageCredit'],
                experienceLevel: payload['experienceLevel'],
                learningApproach: payload['learningApproach'],
                creativeFields: payload['taxonomy'] ? [...payload['taxonomy']['creative_fields']] : [],
                topics: payload['taxonomy'] ? [...payload['taxonomy']['topics']] : [],
                tasks: payload['taxonomy'] ? [...payload['taxonomy']['tasks']] : [],
                tools: payload['taxonomy'] ? [...payload['taxonomy']['tools']] : [],
                locale: payload['locale'],
                //isEnglishLocale: payload["isEnglishLocale"],
                createdOn: payload['createdOn'],
                modifiedOn: payload['modifiedOn'],
                completionMessage: payload['completionMessage'],
                completionMedia: payload['completionMedia'],
                ututCreator: payload['ututCreator'],
                creatorAvatar: payload['creatorAvatar'],
                creatorBio: payload['creatorBio'],
                creatorBadge: payload['creatorBadge'],
                curatorFeedback: payload['curatorFeedback'],
                transientDocId: payload['transientDocId'],
                templateSize: payload['templateSize'],
                templateNeedLoc: payload['templateNeedLoc'],
                imageCreditToAuthor: payload['imageCreditToAuthor'],
                taxonomy: payload['taxonomy'],
                relatedContents:
                    payload['relatedContents'] &&
                    payload['relatedContents'].length > 0 &&
                    payload['relatedContents'][0] &&
                    Object.keys(payload['relatedContents'][0]).length > 0
                        ? [...payload['relatedContents']]
                        : [],
                //totalExperienceLevels: [...payload["totalExperienceLevels"]],
                //  totalCreativeFields: [...payload["totalCreativeFields"]],
                //    totalTasks: [...payload["totalTasks"]],
                //   totalTools: [...payload["totalTools"]],
                //  totalTopics: [...payload["totalTopics"]],
            };
        case tbwMetadataActionTypes.RESET_META_DATA:
            return {
                ...intialState,
            };
        default:
            return state;
    }
};
